<template>
  <div class="mFooter-container">
     <div class="mLogo-container">
      <img :src="logoIcon" alt="Nueva Tecate 0.0, perfecta para disfrutar con tus comidas favoritas" width="1538" height="941"/>
    </div> 
    <div class="mPrivacy-container">
      <div class="mPrivacy-links">
        <h2 class="privacy clickable" @click="popUpModal('terms') & footerGA4Click('click', 'terminos y condiciones', 'footer')">
          Términos y Condiciones
        </h2>
        <span class="privacy bar">|</span>
        <h2 class="privacy clickable" @click="popUpModal('politics') & footerGA4Click('click', 'politica de privacidad', 'footer')">
          Aviso de Privacidad
        </h2>
        <span class="privacy bar">|</span>
        <h2 class="privacy clickable" @click="popUpModal('cookies') & footerGA4Click('click', 'politica de cookies', 'footer')">
          Política de Cookies
        </h2>
        <span class="privacy bar" v-if="showInfoOption">|</span>
        <h2 class="privacy clickable" v-if="showInfoOption" @click="(showModalInfo = true) & footerGA4Click('click', 'informacion del producto', 'footer')">
          Información del producto
        </h2>
      </div>
     
    </div>
    <Modal
      v-if="showModal"
      v-bind:wichModal="wichModal"
      @close="showModal = false"
    />
    <ModalInfo v-if="showModalInfo" @close="showModalInfo = false"></ModalInfo>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import ModalInfo from "@/components/ModalInfoProduct";
import logoIcon from "@/assets/TECATELOGO.png";
import fbIcon from "@/assets/redes-sociales/FACEBOOK.png";
import twIcon from "@/assets/redes-sociales/TWITTER.png";
import inIcon from "@/assets/redes-sociales/INSTAGRAM.png";
import pintIcon from "@/assets/redes-sociales/PINTEREST.png";
import tagFunctions from '@/utils/tagFunctions.js'

const utm1 = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Tecate00",
};

export default {
  name: "FooterHome",
  data() {
    return {
      showModal: false,
      wichModal: "terms",
      showModalInfo: false,
      showInfoOption: false,
      logoIcon,
      fbIcon,
      twIcon,
      inIcon,
      pintIcon,
    };
  },
  mounted() {
    const { utm_source, utm_medium, utm_content } = this.$route.query;
    if (
      utm1["utm_source"] === utm_source &&
      utm1["utm_content"] === utm_content &&
      utm1["utm_medium"] === utm_medium
    ) {
      setTimeout(() => {
        this.showInfoOption = true;
      }, 3000);
    }
  },
  methods: {
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    footerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section);
    },
  },
  components: {
    Modal,
    ModalInfo
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/FooterHome.scss";
</style>
